import { colors } from '@karnott/colors';
import CircledIcon from '../utils/circledIcon';

export const MagicEditIcon = ({ color = '#000', size = 30, backgroundColor = colors('grey'), circled = false }) => (
  <CircledIcon {...{ backgroundColor, circled, size }}>
    <svg
      width={circled ? '50%' : '100%'}
      height={circled ? '50%' : '100%'}
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.0392 9.54142L16.9392 8.64142C17.2392 8.34142 17.7392 8.34142 17.9392 8.64142L20.1392 10.8414C20.4392 11.1414 20.4392 11.6414 20.1392 11.8414L12.8392 19.1414"
        stroke={color}
        strokeWidth="0.8"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <path
        d="M9.63922 16.0414L10.8392 14.8414"
        stroke={color}
        strokeWidth="0.8"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <path
        d="M9.63923 16.0414L7.83923 21.0414L12.8392 19.2414L11.6392 18.0414L10.3392 16.7414L9.63923 16.0414Z"
        stroke={color}
        strokeWidth="0.8"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <path
        d="M5.13923 2.94142L5.43923 3.74142C5.93923 5.14142 7.13923 6.34142 8.53923 6.84142L9.33923 7.14142C9.53923 7.14142 9.63923 7.44142 9.53923 7.64142C9.53923 7.74142 9.43923 7.84142 9.33923 7.84142L8.53923 8.14142C7.13923 8.64142 5.93923 9.84142 5.43923 11.2414L5.13923 12.0414C5.13923 12.2414 4.83923 12.3414 4.63923 12.2414C4.53923 12.2414 4.43923 12.1414 4.43923 12.0414L4.13923 11.2414C3.63923 9.84142 2.43923 8.64142 1.03923 8.14142L0.23923 7.84142C0.0392303 7.84142 -0.0607695 7.54142 0.0392305 7.34142C0.0392305 7.24142 0.13923 7.14142 0.23923 7.14142L1.03923 6.84142C2.43923 6.34142 3.63923 5.14142 4.13923 3.74142L4.43923 2.94142C4.43923 2.74142 4.73923 2.64142 4.93923 2.74142C5.03923 2.74142 5.13923 2.84142 5.13923 2.94142Z"
        fill={color}
      />
      <path
        d="M13.6392 0.141422L13.8392 0.641422C14.1392 1.44142 14.8392 2.14142 15.6392 2.44142L16.1392 2.64142C16.2392 2.64142 16.3392 2.84142 16.2392 2.94142C16.2392 2.94142 16.2392 3.04142 16.1392 3.04142L15.6392 3.24142C14.8392 3.54142 14.1392 4.24142 13.8392 5.04142L13.6392 5.54142C13.6392 5.64142 13.4392 5.74142 13.3392 5.64142C13.3392 5.64142 13.2392 5.64142 13.2392 5.54142L13.0392 5.04142C12.7392 4.24142 12.0392 3.54142 11.2392 3.24142L10.7392 3.04142C10.6392 3.04142 10.5392 2.84142 10.6392 2.74142C10.6392 2.74142 10.6392 2.64142 10.7392 2.64142L11.2392 2.44142C12.0392 2.14142 12.7392 1.44142 13.0392 0.641422L13.2392 0.141422C13.2392 0.0414217 13.4392 -0.0585787 13.5392 0.0414213C13.5392 0.0414213 13.6392 0.0414217 13.6392 0.141422Z"
        fill={color}
      />
      <path
        d="M13.6392 9.54142L13.8392 10.0414C14.1392 10.8414 14.8392 11.5414 15.6392 11.8414L16.1392 12.0414C16.2392 12.0414 16.3392 12.2414 16.2392 12.3414C16.2392 12.3414 16.2392 12.4414 16.1392 12.4414L15.6392 12.6414C14.8392 12.9414 14.1392 13.6414 13.8392 14.4414L13.6392 14.9414C13.6392 15.0414 13.4392 15.1414 13.3392 15.0414C13.3392 15.0414 13.2392 15.0414 13.2392 14.9414L13.0392 14.4414C12.7392 13.6414 12.0392 12.9414 11.2392 12.6414L10.7392 12.4414C10.6392 12.4414 10.5392 12.2414 10.6392 12.1414C10.6392 12.1414 10.6392 12.0414 10.7392 12.0414L11.2392 11.8414C12.0392 11.5414 12.7392 10.8414 13.0392 10.0414L13.2392 9.54142C13.2392 9.44142 13.4392 9.34142 13.5392 9.44142C13.5392 9.44142 13.6392 9.44142 13.6392 9.54142Z"
        fill={color}
      />
    </svg>
  </CircledIcon>
);
